import { ehProducao } from "./ambiente";
import { sleep } from "./utils";

export async function kondutoSetCustomerID(idUser, isB2B) {
  try {
    if (!ehProducao()) {
      return;
    }
    if (isB2B) {
      await initKonduto("P2154010979");
    } else {
      await initKonduto("PF561A6FF2D");
    }
    let count = 0;
    while (count < 10) {
      if (window.Konduto) {
        window.Konduto.setCustomerID(idUser);
        count = 999;
      }
      await sleep(2000);
      count++;
    }
  } catch (e) {
    console.log(e);
  }
}

export async function trackKonduto(page, isB2B) {
  try {
    if (!ehProducao()) {
      return;
    }
    if (isB2B) {
      await initKonduto("PF561A6FF2D");
    } else {
      await initKonduto("P96F58C38C2");
    }
    console.log("track page", page);
    window.Konduto.sendEvent("page", page);
  } catch (e) {
    console.log(e);
  }
}

async function initKonduto(key) {
  const scriptKonduto = document.getElementById("kdtjs");
  if (!scriptKonduto) {
    console.log("load kdt script");
    var __kdt = window.__kdt || [];
    __kdt.push({ public_key: key });
    __kdt.push({ post_on_load: false });
    window.__kdt = __kdt;
    (function () {
      var kdt = document.createElement("script");
      kdt.id = "kdtjs";
      kdt.type = "text/javascript";
      kdt.async = true;
      kdt.src = "https://i.k-analytix.com/k.js";
      var s = document.getElementsByTagName("body")[0];
      s.parentNode.insertBefore(kdt, s);
    })();
    await sleep(2000);
  }
}
